import React, {useState, useRef, useEffect} from 'react';
import '../../css/conversation.css';
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { useSelector } from 'react-redux';
import MessageBlock from './message';
import SendBar from './sendBar';
import { fileServer } from '../../config/commUrls';
import Icon from '../../assets/icons/icon';

function ActualConversation({setLoading,lead,conversation,travelPathway,handleSendText,convoId,handleInputChange,inputValue}) {
    const agentInfo=useSelector((state) => state.agent.userData);
    const textingNumbers = useSelector((state) => state.agent.textingNumbers)
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [attachedImage, setAttachedImage] = useState(false);
    const sendBarRef = useRef();
    const [textBoxHeight, setTextBoxHeight] = useState(0);

    const handleRemoveImage=()=>{
        setAttachedImage(false);
    }
    const handleEmojiSelect = (emoji) => {
        handleInputChange(inputValue+emoji.native);
    };
    const handleEmojiPicker=()=>{
        setShowEmojiPicker(!showEmojiPicker);
    }
    const handleFileUpload = async (e) => {
        const file = e.target.files[0];

        const formData = new FormData();

        formData.append('file', file);

        try {
            const backend_port = process.env.REACT_APP_BACKEND_PORT ? process.env.REACT_APP_BACKEND_PORT : 3333
            const backend_url = process.env.REACT_APP_FUNNEL_HOSTNAME ? process.env.REACT_APP_FUNNEL_HOSTNAME : window.location.hostname
            const csrfToken = await localStorage.getItem('keepMeAlive');
            const response = await fetch(`${backend_url}:${backend_port}/sendImage?lead=${lead[0].lead_id}`, {
                method: 'POST',
                body: formData,
                headers : {'X-CSRF-Token': csrfToken }
            });
            const jsonData = await response.json();
            setAttachedImage(`${fileServer}/mmsImages/${jsonData[0].file}`)
        } catch (error) {
            console.error('Error:', error.message);
        }
    };
    const sendSuggestion=async(template)=>{
        let modifiedContent = Object.entries(lead[0]).reduce((content, [key, value]) => {
            const replacement = value !== null ? value : '';
            return content.replace(new RegExp(`{${key.replace('borrower','lead')}}`, 'g'), `${replacement}`);
        }, template);
        if(modifiedContent.includes('{agent_first}')){
            modifiedContent = modifiedContent.replace(/{agent_first}/g, agentInfo.firstName);
        }
        if(modifiedContent.includes('{agent_last}')){
            modifiedContent = modifiedContent.replace(/{agent_last}/g, agentInfo.lastName);
        }
        travelPathway(lead[0].lead_id, lead[0].pathway);
        handleChange(modifiedContent);
        lead[0].pathway=null;
    }
    // console.log("lead==$$",lead[0])

    // Function to handle input change
    const handleChange = (value) => {
        handleInputChange(value);
    };

    useEffect(() => {
        if(lead){
            if(lead[0].pathway){
                setTextBoxHeight(243);
            }
            else{
                setTextBoxHeight(193);
            }

        }
        else{
            setTextBoxHeight(103);
        }
        handleInputChange('')
    }, [lead && lead[0].lead_id]);

    const unassocNumberRef = useRef()
    const [agentNumNoLongerAvailable, setAgentNumNoLongerAvailable] = useState(false)
    const [noPhoneWrapperHeight, setNoPhoneWrapperHeight] = useState(0)

    const checkCurrentConversationAgentNumber = () => {
        if(textingNumbers.length === 0 || !convoId){
            return true
        }

        const convoString = atob(convoId);
        // Split the input string based on the colon
        const numbersArray = convoString.split(':');

        if(!numbersArray[0]){
            return true
        }

        for (let index = 0; index < textingNumbers.length; index++) {
            const {number, friendlyName} = textingNumbers[index];


            if(numbersArray[0] === number || numbersArray[0] === friendlyName){
                return false
            }
        }

        return true
    }

    useEffect(()=>{
        let numberNoLongerAvailable = false

        // only run check when currentConvoId is not false
        if(convoId){
            numberNoLongerAvailable = checkCurrentConversationAgentNumber()
            setAgentNumNoLongerAvailable(numberNoLongerAvailable)
        }


        // adjust convo wrapper based on the visibility of the unassociated div
        if(unassocNumberRef.current){
            // handleHeight((numberNoLongerAvailable ? -1 : 1) * unassocNumberRef.current.clientHeight)

            if(numberNoLongerAvailable) {
                setNoPhoneWrapperHeight(unassocNumberRef.current.clientHeight)
            } else {
                setNoPhoneWrapperHeight(0)
            }
        }

    }, [convoId, textingNumbers])

    return (
        <div className="outerConvo" style={{height: `calc(100% - ${noPhoneWrapperHeight}px)`}}>
            <div className="convoInnerWrapper" style={{height: `calc(100% - ${textBoxHeight + 24}px)`}}>
                {conversation && conversation.map((message, index) => (
                    <MessageBlock message={message} index={index} key={index}/>
                ))}
            </div>

            <div className="sendWrapper" ref={sendBarRef}>
                {lead.length > 0 && lead[0].pathway && (
                    <div className="pathSuggestion">
                        <div className="suggestionHolder">
                            <div className="suggestion" onClick={()=>sendSuggestion(lead[0].convoFlowContent)}><span className="fontello" style={{marginTop: '-7px', marginRight:'10px'}}><Icon name={'q-lightning-bolt-fast'} size={24} className="suggestionIcon" adjust="fontello" /></span>{lead[0].convoFlowName}</div>
                        </div>
                    </div>
                )}
                <div className="sendingImageWrapper">
                    {attachedImage && (
                        <div className="innerImageWrapper">
                            <div className="removeImage" onClick={()=>handleRemoveImage()}>x</div>
                            <img src={attachedImage} alt="Preview" className="sendingImage"/>
                        </div>
                    )}
                </div>
                {agentNumNoLongerAvailable && (
                    <div ref={unassocNumberRef} style={{ paddingLeft: 16, paddingRight: 16, paddingTop: 12, paddingBottom: 12, background: '#F95951', overflow: 'hidden', borderRadius: 6, justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex'}}>
                        <div style={{justifyContent: 'center', display: 'flex', flexDirection: 'column'}}>
                            <span style={{color: 'white', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '500', wordWrap: 'break-word'}}>Phone Number No Longer Available</span>
                            <span style={{color: 'white', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word'}}>This phone number is no longer active on your account. Try starting a new conversation with your current active number.</span>
                        </div>
                        <div style={{width: 18, height: 18, position: 'relative'}}>
                            <Icon name="q-alert-octagon" size={20} className="" adjust="fontello" color='#FFFFFF' viewBox="0 0 1024 700"></Icon>
                        </div>
                    </div>
                )}
                <SendBar handleFileUpload={handleFileUpload} handleEmojiPicker={handleEmojiPicker} attachedImage={attachedImage} setTextBoxHeight={setTextBoxHeight} handleChange={handleChange} handleInputChange={handleInputChange} inputValue={inputValue} handleSendText={handleSendText} convoId={convoId} setLoading={setLoading} setAttachedImage={setAttachedImage} sendBarRef={sendBarRef} lead={lead} disabled={agentNumNoLongerAvailable}/>
            </div>
            {showEmojiPicker && (
                <div className="emojiWrapper" style={{ position: 'absolute',bottom: '100px'}} >
                    <Picker
                        data={data} onEmojiSelect={handleEmojiSelect}
                    />
                </div>
            )}
        </div>
    );
}

export default ActualConversation;
